import React, { useEffect, useState } from "react";
import Loadspinner from "./Loadspinner";
import Main from "./Main/Main";
import BookmarksService from "../services/BookmarksService";
import DataCards2 from "../common/DataCards2/DataCards2";
import PropTypes from "prop-types";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";
// import Decrypt from "../services/Decryption";


function Bookmarks(props) {
  const [isLoading, setLoading] = useState(false);
  const [bookmarkList, setBookmarkList] = useState([]);
  const [ismore, setMore] = useState(true);

  useEffect(() => {
    //getBookmarkList(1);
    getBookmarkListNew(1);
  }, []);

  // const getBookmarkList = async (page) => {
  //   let scrollPosition = getFromEncLocalStorage("position");
  //   setLoading(true);
  //   let reqBody = {
  //     limit: 10,
  //     pageNo: page,
  //   };
  //   const res = await BookmarksService.getBookmarks(reqBody);

  //   if (res) {
  //     if (res.length < 10) {
  //       setMore(false);
  //     }
  //     if (page == 1) {
  //       setBookmarkList(res);
  //     } else {
  //       let data = [...bookmarkList, ...res];
  //       setBookmarkList(data);
  //     }
  //   }
  //   if (props.location.state != undefined) {
  //     window.scrollTo(0, scrollPosition);
  //   }
  //   setLoading(false);
  // };

  const getBookmarkListNew = async (start) => {
    setLoading(true);
    let scrollPosition = getFromEncLocalStorage("position");
    const employeeNum = getFromEncLocalStorage("employeenumber");
    const reqBody = {
      start: (start - 1) * 10,
      resultsPerPage: 10,
      searchText: "",
      sortColumn: "",
      sortDirection: "",
      userId: employeeNum
    }
    const res = await BookmarksService.getAllBookmarks(reqBody);

    if (res) {
      if (res?.data?.length < 10) {
        setMore(false);
      }
      if (start == 0) {
        setBookmarkList(res?.data);
      } else {
        let data = [...bookmarkList, ...res?.data];
        setBookmarkList(data);
      }
    }
    if (props.location.state != undefined) {
      window.scrollTo(0, scrollPosition);
    }
    setLoading(false);
  };

  const rerender = (val) => {
    //getBookmarkList(val);
    getBookmarkListNew(val);
  };

  return (
    <Main active={"bookmarks"}>
      <Loadspinner filename="Bookmarks.js" isLoading={isLoading} isMiddle="true" />
      <div className="container display-col justify-space-evenly">
        <DataCards2
          dataList={bookmarkList}
          rerenderParentCallback={rerender}
          ismore={ismore}
          isBookmarks={true}
        />
      </div>
    </Main>
  );
}

export default Bookmarks;

Bookmarks.propTypes = {
  location: PropTypes.object,
};
